/* toggle ccv tooltip */
$(function(){
    var formTooltip = $('[data-form-tooltip]');
    if( formTooltip.length ) {
        formTooltip.click(function(){
            $(this).next().toggle();
        });
    }
})
